import type { ReactNode } from 'react';

import {
  AppstoreOutlined,
  BarChartOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  FileOutlined,
  GlobalOutlined,
  SettingOutlined,
  TeamOutlined,
} from '@ant-design/icons';

/**
 * Map chuỗi `icon` từ BE sang icon Ant (fallback khi không khớp).
 */
export function menuIconFromString(icon: string | null | undefined): ReactNode {
  const key = (icon ?? '').trim().toLowerCase();
  switch (key) {
    case 'dashboard':
    case 'home':
      return <DashboardOutlined />;
    case 'chart':
    case 'analytics':
    case 'barchart':
      return <BarChartOutlined />;
    case 'database':
    case 'netcdf':
    case 'data':
      return <DatabaseOutlined />;
    case 'file':
      return <FileOutlined />;
    case 'global':
    case 'map':
      return <GlobalOutlined />;
    case 'settings':
    case 'setting':
      return <SettingOutlined />;
    case 'team':
    case 'users':
      return <TeamOutlined />;
    default:
      return <AppstoreOutlined />;
  }
}
